import { Box, Typography, Button, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { BaseListStyle as styles } from "./BaseListStyle";
import { useBaseList } from "../hooks/logic/useBaseList";
import BaseListTable from "../components/Table/BaseListTable";
import EditBaseDialog from "../components/EditBaseDialog";
import AddBaseDialog from "../components/AddBaseDialog";
import BaseUsersListDialog from "../components/BaseUsersListDialog";

const BaseList = () => {
  const {
    inputRef,
    baseList,
    baseUserList,
    selectedRow,
    checkedIds,
    handleCheckChange,
    handleUpdate,
    handleRegister,
    handleRowClick,
    handleUserListClick,
    editDialogOpen,
    setEditDialogOpen,
    addBaseDialogOpen,
    baseUsersListDialogOpen,
    setBaseUsersListDialogOpen,
    setAddBaseDialogOpen,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    handleCancel,
    handleDelete,
    handleCheckChangeAll,
  } = useBaseList();
  const FOOTER_HEIGHT = 60;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <EditBaseDialog
        open={editDialogOpen}
        onClose={() => {
          setEditDialogOpen(false);
        }}
        statusId={4}
        baseInfo={selectedRow!}
        onUpdate={handleUpdate}
      />
      <AddBaseDialog
        open={addBaseDialogOpen}
        onClose={() => {
          setAddBaseDialogOpen(false);
        }}
        statusId={4}
        onResiter={handleRegister}
      />
      <BaseUsersListDialog
        open={baseUsersListDialogOpen}
        onClose={() => {
          setBaseUsersListDialogOpen(false);
        }}
        userInfo={baseUserList}
      />
      <Box sx={styles.titleBar}>
        <Typography variant="h6" sx={styles.titleText}>
          拠点一覧
        </Typography>
      </Box>
      <Box py={0} px={0}>
        <Box mt={2} ml={2}>
          <Button
            variant="contained"
            sx={styles.orangeButton}
            onClick={() => setAddBaseDialogOpen(true)}
          >
            拠点追加
          </Button>
        </Box>
        <Box mt={2}>
          <BaseListTable
            bases={baseList}
            checkedIds={checkedIds}
            onCheckedChange={handleCheckChange}
            onCheckedChangeAll={handleCheckChangeAll}
            onRowClick={handleRowClick}
            onShowUserList={handleUserListClick}
            footerHeight={FOOTER_HEIGHT}
          ></BaseListTable>
          {checkedIds.size > 0 && (
            <Box
              sx={{
                position: "fixed",
                height: `${FOOTER_HEIGHT}px`,
                bottom: 0,
                right: 0,
                width: "100%",
                bgcolor: "white",
                borderTop: "1px solid #ccc",
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
            >
              <Box gap={2} sx={{ marginLeft: "240px" }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Typography>全{checkedIds.size}件選択されています</Typography>
                </Box>
                <Box display="flex" gap={2}>
                  <Button variant="outlined" onClick={handleCancel}>
                    キャンセル
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleDelete}
                  >
                    拠点削除
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      <Snackbar
        open={toastOpen}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseToast}
          severity={toastSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default BaseList;
